RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.EmptySocialHandles = Marionette.ItemView.extend({
        template: '#adminCompanyEmptySocialHandlesTemplate',
        tagName: 'li',
        className: 'list-group-item'
    });
});
